import { useState } from 'react'
import {
    AccountRecord,
    useAddTwitterSubscriptionMutation,
    useRemoveTwitterSubscriptionMutation
} from '../../api/client'
import Toggle from './Toggle'

const TwitterActivityApiToggle = ({ account }: { account: AccountRecord }) => {
    const [addTwitterSubscription, { loading: addLoading }] = useAddTwitterSubscriptionMutation()
    const [removeTwitterSubscription, { loading: removeLoading }] =
        useRemoveTwitterSubscriptionMutation()

    const [subscriptionEnabled, setSubscriptionEnabled] = useState(account.isSubscribed)

    const onToggle = async (isEnabled: boolean) => {
        // Optimistic flip for responsiveness, reverted if the mutation fails.
        // Enabling fails legitimately whenever X rejects the subscription —
        // e.g. the Account Activity product isn't on our X plan — and without
        // the revert the toggle would show "on" for an account that was never
        // subscribed.
        setSubscriptionEnabled(isEnabled)
        try {
            if (isEnabled) {
                await addTwitterSubscription({
                    variables: { accountId: account.id }
                })
            } else {
                await removeTwitterSubscription({
                    variables: { accountId: account.id }
                })
            }
        } catch {
            setSubscriptionEnabled(!isEnabled)
        }
    }

    return (
        <Toggle
            id={`activity-api-${account.id.toString()}`}
            disabled={false}
            checked={subscriptionEnabled}
            label="Activity API"
            loading={addLoading || removeLoading}
            onToggle={onToggle}
            tooltip="If enabled this will allow X to send us Comments as soon as they happen."
            size="small"
        />
    )
}

export default TwitterActivityApiToggle
